import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ComboBox, InputWithLabel } from '@reveni-io/reveni-ui'

import { optionTypes, types } from './constants'
import * as Styles from './styles'

const LastUpdateFilter = ({
  onChangeLastUpdatedGte,
  onChangeLastUpdatedLte,
  lastUpdatedGteValue,
  lastUpdatedLteValue,
}) => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState(lastUpdatedGteValue || lastUpdatedLteValue)
  const [typeSelected, setTypeSelected] = useState(lastUpdatedGteValue ? types.gte : types.lte)

  const onChangeFunctions = {
    gte: onChangeLastUpdatedGte,
    lte: onChangeLastUpdatedLte,
  }

  const handleChange = e => {
    const newValue = e.target.value
    setInputValue(newValue)

    if (!newValue) {
      onChangeLastUpdatedGte(null)
      onChangeLastUpdatedLte(null)
    } else {
      if (Number(newValue) >= 0 && Number.isInteger(Number(newValue))) {
        onChangeFunctions[typeSelected](Number(newValue))
      }
    }
  }

  const handleChangeComboBox = e => {
    const value = e.target.value
    setTypeSelected(value)

    if (value === types.gte) {
      onChangeLastUpdatedLte(null)
      onChangeLastUpdatedGte(inputValue)
    } else {
      onChangeLastUpdatedGte(null)
      onChangeLastUpdatedLte(inputValue)
    }
  }

  return (
    <Styles.MainContainer>
      <p>{t('Actualizado hace')}</p>
      <InputWithLabel type="number" value={inputValue} onChange={handleChange} />
      <p>{t('días')}</p>
      <ComboBox
        value={typeSelected}
        menuItems={optionTypes.map(type => ({
          label: t(type.label),
          value: type.value,
        }))}
        handleChange={handleChangeComboBox}
      />
    </Styles.MainContainer>
  )
}

export default LastUpdateFilter
